import { useFilterQuoteActivityContext } from "./filter-quote-activity.context";

export function FilterQuoteActivity() {
  const { dateFilterElement, clearFiltersElement } =
    useFilterQuoteActivityContext();

  return (
    <div>
      <h2>Filters</h2>
      <p className="mb-4">
        Select the following filters you want to apply to the current table.
      </p>

      {dateFilterElement}
      {clearFiltersElement}
    </div>
  );
}